import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleBrandListPage" */
	'pages/vehicle/VehicleBrand/VehicleBrandListPage'));

export default [{ component, exact: true, path: '/vehicle_brands' }];